import React from 'react';
import { useArrowStore } from '@/stores/arrowStore';
import { 
  ArrowRight, 
  ArrowLeft, 
  ArrowLeftRight, 
  Minus,
  ArrowRightLeft,
} from 'lucide-react';
import { RailButton, RailDivider } from './RailButton';

export function ArrowFormattingSidebar() {
  const { selectedArrowId, arrows, updateArrow } = useArrowStore();
  
  const selectedArrow = arrows.find(a => a.id === selectedArrowId);
  
  if (!selectedArrow) return null;
  
  const handleToggleStartArrow = () => {
    updateArrow(selectedArrow.id, { 
      start_arrowhead: !selectedArrow.start_arrowhead 
    });
  };
  
  const handleToggleEndArrow = () => {
    updateArrow(selectedArrow.id, { 
      end_arrowhead: !selectedArrow.end_arrowhead 
    });
  };
  
  const handleSwapArrows = () => {
    updateArrow(selectedArrow.id, { 
      start_arrowhead: selectedArrow.end_arrowhead,
      end_arrowhead: selectedArrow.start_arrowhead,
    });
  };
  
  const handleNoArrows = () => {
    updateArrow(selectedArrow.id, { 
      start_arrowhead: false,
      end_arrowhead: false,
    });
  };
  
  const handleBothArrows = () => {
    updateArrow(selectedArrow.id, { 
      start_arrowhead: true,
      end_arrowhead: true,
    });
  };
  
  // Determine current state for highlighting
  const hasStartOnly = selectedArrow.start_arrowhead && !selectedArrow.end_arrowhead;
  const hasEndOnly = !selectedArrow.start_arrowhead && selectedArrow.end_arrowhead;
  const hasBoth = selectedArrow.start_arrowhead && selectedArrow.end_arrowhead;
  const hasNone = !selectedArrow.start_arrowhead && !selectedArrow.end_arrowhead;

  return (
    <div className="flex flex-col items-center animate-fade-in">
      {/* Arrowhead configuration */}
      <div className="flex flex-col items-center gap-0.5">
        <RailButton
          icon={ArrowRight}
          label="Arrow at end"
          isActive={hasEndOnly}
          onClick={() => updateArrow(selectedArrow.id, { start_arrowhead: false, end_arrowhead: true })}
        />
        <RailButton
          icon={ArrowLeft}
          label="Arrow at start"
          isActive={hasStartOnly}
          onClick={() => updateArrow(selectedArrow.id, { start_arrowhead: true, end_arrowhead: false })}
        />
        <RailButton
          icon={ArrowLeftRight}
          label="Arrows on both ends"
          isActive={hasBoth}
          onClick={handleBothArrows}
        />
        <RailButton
          icon={Minus}
          label="No arrows (line only)"
          isActive={hasNone}
          onClick={handleNoArrows}
        />
      </div>

      <RailDivider />

      {/* Swap */}
      <div className="flex flex-col items-center gap-0.5">
        <RailButton
          icon={ArrowRightLeft}
          label="Swap arrow direction"
          onClick={handleSwapArrows}
        />
      </div>
    </div>
  );
}
